// Default filters required for querying properties
export const EDP_MATCH_VERIFIED_FILTER = {
  type: 'equal',
  field: 'edp_match_verified_f',
  values: 'true',
  dataType: 'boolean',
  name: 'EDP Match Verified',
};

export const DEFAULT_EDP_MATCH_VERIFIED_FILTER = {
  type: 'multiNotEqual',
  field: 'edp_match_verified_f',
  values: ['false'],
  dataType: 'boolean',
  name: 'EDP Match Verified',
};

export const SHOW_NON_HIDDEN_RECORDS = {
  type: 'multiNotEqual',
  field: 'miq_record_hide_f',
  dataType: 'boolean',
  values: [true],
};

export const FILTER_HIDDEN_RECORD = {
  type: 'equal',
  field: 'miq_record_hide_f',
  values: 'false',
  dataType: 'boolean',
  name: 'Hide Property',
};

export const DEFAULT_GEOGRAPHY_FILTER = {
  markets: [],
  propertyTypes: [],
  submarkets: [],
  districts: [],
  neighborhoods: [],
};

export const DEFAULT_REQUIRED_FILTERS = [EDP_MATCH_VERIFIED_FILTER];
